import { createSlotRecipe } from './runtime.js';

const accordionListConfig = {"name":"accordionList","slots":["root","summary","listItem","startIcon","endIcon","root","summary","listItem","startIcon","endIcon"],"variantMap":{"dense":["true"],"disabled":["true"],"expanded":["true"],"selected":["true"]}}

export const accordionList = /* @__PURE__ */ createSlotRecipe(accordionListConfig)